import Vue from 'vue'
import vuetify from './plugins/vuetify'
import VueRouter from 'vue-router'

import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'

//라이브러리
import axios from 'axios'               //http library
import querystring from 'querystring'   //axios랑 함께 써야하는 라이브러리 (post 파라메터 전송)
import VueSessionStorage from 'vue-sessionstorage'  //저장소
import colors from 'vuetify/lib/util/colors'        //컬러픽커

import AWS from 'aws-sdk';              //아마존 sdk
var s3 = new AWS.S3({
  "accessKeyId": process.env.VUE_APP_UPLOADK,		
  "secretAccessKey": process.env.VUE_APP_UPLOADS,
  "region": process.env.VUE_APP_UPLOADR,
  params:{Bucket:process.env.VUE_APP_UPLOADB}
});
Vue.prototype.$s3 = s3

import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
Vue.use(Datetime);

//다국어
import { i18n } from "@/locales/i18n";


import VueSimpleAlert from "vue-simple-alert";
Vue.prototype.$alert_option = {reverseButtons: true, allowEnterKey:false, confirmButtonText: "확인", cancelButtonText:"취소", allowEscapeKey:true, focusConfirm:true}; 
Vue.use(VueSimpleAlert, Vue.prototype.$alert_option);  //엔터를 처도 팝업창 클로즈 안함. (sweetalert2 라이브러리 옵션 참고)

//화면단
import App from './App.vue'
import AdminBanner from './components/AdminBanner.vue'
import AdminNotice from './components/AdminNotice.vue'
import AdminStat from './components/AdminStat.vue'
import AdminLayout from './components/AdminLayout.vue'
import ComAcnt from './components/ComAcnt.vue'
import Company from './components/Company.vue'
import ChartPayment from './components/ChartPayment.vue'
import ChartServey from './components/ChartServey.vue'
import ChartReview from './components/ChartReview.vue'
import ChartUserInfo from './components/ChartUserInfo.vue'
import ChartUserPrint from './components/ChartUserPrint.vue'
import ChartStepPrint from './components/ChartStepPrint.vue'
import ChartEventPayment from './components/ChartEventPayment.vue'
import ChartEventUser from './components/ChartEventUser.vue'
import ChartEventUserInfo from './components/ChartEventUserInfo.vue'
import ChartEventUserPrint from './components/ChartEventUserPrint.vue'
import ChartEventStepPrint from './components/ChartEventStepPrint.vue'
import VisitorComout from './components/VisitorComout.vue'
import VisitorComoutCompany from './components/VisitorComoutCompany.vue'
import VisitorComoutPlace from './components/VisitorComoutPlace.vue'
import VisitorPrintList from './components/VisitorPrintList.vue'
import KioskPrintList from './components/KioskPrintList.vue'
import ReviewList from './components/ReviewList.vue'

import DeviceAdmin from './components/DeviceAdmin.vue'
import DeviceAdminSetting from './components/DeviceAdminSetting.vue'
import DeviceAdminBG from './components/DeviceAdminBG.vue'
import DeviceList from './components/DeviceList.vue'
import EventDesign from './components/EventDesign.vue'

import GuestDesign from './components/GuestDesign2.vue'

import EventFormat from './components/EventFormat.vue'
import EventFormatReview from './components/EventFormatReview.vue'
import EventInfo from './components/EventInfo.vue'
import EventInfoCraw from './components/EventInfoCraw.vue'
import EventList from './components/EventList.vue'
import EventListCraw from './components/EventListCraw.vue'
import EventNotice from './components/EventNotice.vue'
import EventSchedule from './components/EventSchedule.vue'
import EventMap from './components/EventMap.vue'
import EventUserList from './components/EventUserList.vue'
import EventUserFormatList from './components/EventUserFormatList.vue'
import EventPaymentList from './components/EventPaymentList.vue'
import InspectUserList from './components/InspectUserList.vue'

import EventPlace from './components/EventPlace.vue'
import EventRefund from './components/EventRefund.vue'
import EventInvit from './components/EventInvit.vue'
import SmsList from './components/SmsList.vue'
import EventRegOption from './components/EventRegOption.vue'

import EmailList from './components/EmailList.vue'
import EmailDetailList from './components/EmailDetailList.vue'
import EmailDesign from './components/EmailDesign.vue'
import EmailTempList from './components/EmailTempList.vue'
import kakaoList from './components/kakaoList.vue'
import kakaoDetailList from './components/kakaoDetailList.vue'
import EmailalimList from './components/EmailalimList.vue'

import GalleryList from './components/GalleryList.vue'
import Login from './components/Login.vue'
import Notice from './components/Notice.vue'
import NoticeDetail from './components/NoticeDetail.vue'
import StepPrintList from './components/StepPrintList.vue'
import StepType from './components/StepType.vue'
import StepList from './components/StepList.vue'
import Welcome from './components/Welcome.vue'
import Join from './components/Join.vue'
import GetPass from './components/GetPass.vue'
import EventArea from './components/EventArea.vue'
import EventType from './components/EventType.vue'
import NationCode from './components/NationCode.vue'
import FontList from './components/FontList.vue'
import InputBasic from './components/InputBasic.vue'
import InputEvent from './components/InputEvent.vue'
import EventOption from './components/EventOption.vue'
import SendPush from './components/SendPush.vue'
import NotFound from './components/NotFound.vue'

import EventDayPoint from './components/EventDayPoint.vue'
import VisitorDayPoint from './components/VisitorDayPoint.vue'

//API
import ApiDoc from './components/ApiDoc.vue'
import apiCommon from './components/apiCommon.vue'
import apiVisitorDelete from './components/apiVisitorDelete.vue'
import apiVisitorInsert from './components/apiVisitorInsert.vue'
import apiVisitorUpdate from './components/apiVisitorUpdate.vue'

//홈페이지 설정
import BasicPolicy from './components/BasicPolicy.vue'
import BasicPolicyEng from './components/BasicPolicyEng.vue'

import PageEdit from './components/PageEdit.vue'
import PageMain from './components/PageMain.vue'
import PageBanner from './components/PageBanner.vue'
import PagePolicy from './components/PagePolicy.vue'
import PagePolicyEng from './components/PagePolicyEng.vue'
import PageSetInfo from './components/PageSetInfo.vue'
import PageCoverInfo from './components/PageCoverInfo.vue'
import PageMainEng from './components/PageMainEng.vue'
import PageSetInfoEng from './components/PageSetInfoEng.vue'

//라이브러리 컴포넌트
import DatetimePicker from 'vuetify-datetime-picker'
Vue.use(DatetimePicker)

//커스텀 컴포넌트
import ComDialog from './components/ComDialog.vue'
import ComDialog2 from './components/ComDialog2.vue'
import ComDatePicker from './components/ComDatePicker.vue'
import ComTimePicker from './components/ComTimePicker.vue'
import EventDialog from './components/EventDialog.vue'
import EventDialog2 from './components/EventDialog2.vue'
import DeviceDialog from './components/DeviceDialog.vue'
import DeviceLoadDialog from './components/DeviceLoadDialog.vue'
import OptionDialog from './components/OptionDialog.vue'
import NoticeDialog from './components/NoticeDialog.vue'
import NoticeShowDialog from './components/NoticeShowDialog.vue'
import NationDialog from './components/NationDialog.vue'
import ComColorPicker from './components/ComColorPicker.vue'
import ComFontDialog from './components/ComFontDialog.vue'
import ComLayoutDialog from './components/ComLayoutDialog.vue'
import ComDesignUserDialog from './components/ComDesignUserDialog.vue'
import ComDesignStepDialog from './components/ComDesignStepDialog.vue'
import BgGroupDialog from './components/BgGroupDialog.vue'
import AreaDialog from './components/AreaDialog.vue'
import EventTypeDialog from './components/EventTypeDialog.vue'
import StepTypeDialog from './components/StepTypeDialog.vue'
import PlaceDialog from './components/PlaceDialog.vue'
import MailIntroField from './components/MailIntroField.vue'
import ComEmailDesignDialog from './components/ComEmailDesignDialog.vue'
import ComEmailTempList from './components/ComEmailTempList.vue'
import Com_Loading from './components/Com_Loading.vue'
import Dialog_Color from './components/Dialog_Color.vue'
import Dialog_BGColor from './components/Dialog_BGColor.vue'
import Dialog_Font from './components/Dialog_Font.vue'
import Dialog_FontSize from './components/Dialog_FontSize.vue'
import Dialog_FontSize2 from './components/Dialog_FontSize2.vue'
import Dialog_FontAlign from './components/Dialog_FontAlign.vue'
import Dialog_LineHeight from './components/Dialog_LineHeight.vue'


//커스텀 컴포넌트 등록
Vue.component("comdialog",      ComDialog)            //업체 선택
Vue.component("comdialog2",     ComDialog2)           //업체 선택
Vue.component("comdate",        ComDatePicker)        //날자 선택
Vue.component("comtime",        ComTimePicker)        //시간 선택
Vue.component("eventdialog",    EventDialog)          //행사 선택
Vue.component("eventdialog2",    EventDialog2)        //행사 선택 대쉽보드용
Vue.component("devicedialog",    DeviceDialog)        //장비 선택
Vue.component("deviceloaddialog",    DeviceLoadDialog)        //장비 선택
Vue.component("placedialog",    PlaceDialog)          //장소 선택
Vue.component("optiondialog",   OptionDialog)         //행사옵션 선택
Vue.component("mailintrofield", MailIntroField)       //알림메일 상단 안내 문구 입력
Vue.component("noticedialog",   NoticeDialog)         //공지 선택
Vue.component("noticeshowdialog",   NoticeShowDialog)         //공지 보기
Vue.component("nationdialog",   NationDialog)         //국가 선택
Vue.component("comcolor",       ComColorPicker)       //컬러 선택
Vue.component("comfont",        ComFontDialog)        //폰트 선택
Vue.component("comlayout",      ComLayoutDialog)      //레이아웃 선택
Vue.component("comdesignuser",  ComDesignUserDialog)  //참가자명찰 선택
Vue.component("comdesignstep",  ComDesignStepDialog)  //스텝명찰 선택
Vue.component("bggroupdialog",  BgGroupDialog)        //레이아웃 선택
Vue.component("areadialog",     AreaDialog)           //대표장소 선택
Vue.component("eventtypedialog",EventTypeDialog)      //행사타입 선택
Vue.component("steptypedialog", StepTypeDialog)      //스텝타입 선택
Vue.component("emaildialog",    ComEmailDesignDialog)      //이메일 템플릿
Vue.component('datetime',       Datetime);            //날자 및 시간 선택
Vue.component("comemailtempdialog", ComEmailTempList)     //이메일 템플릿 선택
Vue.component("comloading", Com_Loading);
Vue.component("dialogcolor", Dialog_Color);
Vue.component("dialogbgcolor", Dialog_BGColor);
Vue.component("dialogfont", Dialog_Font);
Vue.component("dialogfontsize", Dialog_FontSize);
Vue.component("dialogfontsize2", Dialog_FontSize2);
Vue.component("dialogfontalign", Dialog_FontAlign);
Vue.component("dialoglineheight", Dialog_LineHeight);

//전역변수
Vue.prototype.$http = axios
Vue.prototype.$qstr = querystring

//API 주소는 빌드 모드별 .env 파일의 VUE_APP_APIHOME 을 사용한다.
//  .env                    (기본·운영 빌드)                 https://api.fairpass.co.kr
//  .env.devserver          (npm run deploy, 개발 서버)       https://api.fairpassdev.com
//  .env.development.local  (로컬 npm run serve, git 제외)   http://localhost:8080
Vue.prototype.$host = process.env.VUE_APP_APIHOME;
// Vue.prototype.$host = "http://172.30.1.60:8080"   //로컬 LAN 테스트

Vue.prototype.$hostname = window.location.hostname;   //호스트네임
//Vue.prototype.$hostname = "admin.pictcloud.com";
//console.log("main hostname : " + window.location.hostname);

//국제화(다국어 작업)
Vue.prototype.$lanlist = [{name:'Korean',value:'ko'},{name:'English',value:'en'}];

//개발중에 업데이트 요청오면 false로 바꿔서 업데이트 해야한다.
Vue.prototype.$uselan = true;



//플러그인 사용
Vue.use(VueRouter)
Vue.use(VueSessionStorage)
Vue.use(VueViewer)

Vue.config.productionTip = false

//라우터 인스턴스 생성
const router = new VueRouter({
  mode:'history', //history모드 중요함. 이걸로 해야함.
  routes : [
      {path : "/",              component:Login}
    , {path : "",               component:Login}
    , {path : "/AdminBanner",   component:AdminBanner}
    , {path : "/AdminNotice",   component:AdminNotice}
    , {path : "/AdminStat",     component:AdminStat}
    , {path : "/AdminLayout",   component:AdminLayout}
    , {path : "/ComAcnt",       component:ComAcnt}
    , {path : "/Company",       component:Company}
    , {path : "/ChartPayment",  component:ChartPayment}
    , {path : "/ChartServey",   component:ChartServey}
    , {path : "/ChartReview",   component:ChartReview}
    , {path : "/ChartUserInfo",  component:ChartUserInfo}
    , {path : "/ChartUserPrint", component:ChartUserPrint}
    , {path : "/ChartStepPrint", component:ChartStepPrint}
    , {path : "/ChartEventPayment", component:ChartEventPayment}
    , {path : "/ChartEventUser", component:ChartEventUser}
    , {path : "/ChartEventUserInfo", component:ChartEventUserInfo}
    , {path : "/ChartEventUserPrint", component:ChartEventUserPrint}
    , {path : "/ChartEventStepPrint", component:ChartEventStepPrint}
    , {path : "/VisitorComout", component:VisitorComout}
    , {path : "/VisitorComoutPlace", component:VisitorComoutPlace}
    , {path : "/VisitorComoutCompany", component:VisitorComoutCompany}
    
    , {path : "/VisitorPrintList", component:VisitorPrintList}
    , {path : "/KioskPrintList", component:KioskPrintList}
    , {path : "/ReviewList", component:ReviewList}
    
    , {path : "/DeviceAdmin",   component:DeviceAdmin}
    , {path : "/DeviceAdminSetting",   component:DeviceAdminSetting}
    , {path : "/DeviceAdminBG", component:DeviceAdminBG}
    , {path : "/DeviceList",    component:DeviceList}
    , {path : "/EventDesign",   component:EventDesign}
    , {path : "/GuestDesign",   component:GuestDesign}

    , {path : "/EventFormat",   component:EventFormat}
    , {path : "/EventFormatReview",   component:EventFormatReview}
    , {path : "/EventInfo",     component:EventInfo}
    , {path : "/EventInfoCraw", component:EventInfoCraw}
    , {path : "/EventList",     component:EventList}
    , {path : "/EventListCraw", component:EventListCraw}
    , {path : "/EventMap",      component:EventMap}
    , {path : "/EventNotice",   component:EventNotice}
    , {path : "/EventSchedule", component:EventSchedule}
    , {path : "/EventUserList", component:EventUserList}
    , {path : "/EventUserFormatList", component:EventUserFormatList}
    , {path : "/EventPaymentList", component:EventPaymentList}
    , {path : "/InspectUserList", component:InspectUserList}
    , {path : "/EventPlace",    component:EventPlace}
    , {path : "/EventRefund",   component:EventRefund}
    , {path : "/EventInvit",    component:EventInvit}
    , {path : "/SmsList",       component:SmsList}
    , {path : "/EventRegOption",    component:EventRegOption}
    
    , {path : "/EmailList",       component:EmailList}
    , {path : "/EmailDetailList", component:EmailDetailList}
    , {path : "/EmailDetailList/:rid", component:EmailDetailList}
    , {path : "/kakaoList",       component:kakaoList}
    , {path : "/kakaoDetailList", component:kakaoDetailList}
    , {path : "/kakaoDetailList/:rid", component:kakaoDetailList}
    , {path : "/EmailalimList",       component:EmailalimList}

    , {path : "/EmailDesign",     component:EmailDesign}
    , {path : "/EmailTempList",   component:EmailTempList}
    

    , {path : "/GalleryList",   component:GalleryList}
    , {path : "/Login",         component:Login}
    , {path : "/Notice",        component:Notice}
    , {path : "/NoticeDetail",  component:NoticeDetail}
    
    , {path : "/StepPrintList", component:StepPrintList}
    , {path : "/StepType",      component:StepType}
    , {path : "/StepList",      component:StepList}
    , {path : "/Welcome",       component:Welcome}
    , {path : "/Join",          component:Join}
    , {path : "/Pass",          component:GetPass}

    , {path : "/EventArea",     component:EventArea}
    , {path : "/EventType",     component:EventType}
    , {path : "/NationCode",    component:NationCode}
    , {path : "/FontList",      component:FontList}
    , {path : "/InputBasic",    component:InputBasic}
    , {path : "/InputEvent",    component:InputEvent}
    , {path : "/EventOption",   component:EventOption}
    , {path : "/SendPush",      component:SendPush}

    , {path : "/EventDayPoint",        component:EventDayPoint}
    , {path : "/VisitorDayPoint",      component:VisitorDayPoint}
    
    , {path : "/BasicPolicy",       component:BasicPolicy}
    , {path : "/BasicPolicyEng",    component:BasicPolicyEng}
    , {path : "/PageEdit",          component:PageEdit}
    , {path : "/PageMain",          component:PageMain}
    , {path : "/PagePolicy",        component:PagePolicy}
    , {path : "/PagePolicyEng",     component:PagePolicyEng}
    , {path : "/PageSetInfo",       component:PageSetInfo}
    , {path : "/PageCoverInfo",     component:PageCoverInfo}
    
    , {path : "/PageMainEng",       component:PageMainEng}
    , {path : "/PageSetInfoEng",    component:PageSetInfoEng}
    , {path : "/PageBanner",    component:PageBanner}

    

    , {
      path : "/ApiDoc/", component:ApiDoc, redirect:"/ApiDoc/apiCommon",
      children:[
        {path:'apiCommon',component:apiCommon},
        {path:'apiVisitorInsert',component:apiVisitorInsert},
        {path:'apiVisitorUpdate',component:apiVisitorUpdate},
        {path:'apiVisitorDelete',component:apiVisitorDelete},
      ]
    }

    , {path : "*",              redirect:"/404"}
    , {path : "/404",           component:NotFound}

  ],
  
})

Vue.prototype.$EventBus = new Vue();

new Vue({
    i18n
  , vuetify
  , render: h => h(App)
  , router
  , theme: {
      themes: {
        light: {
          primary: colors.blue.accent1,
          secondary: colors.blue.darken1,
          accent: colors.blue.lighten1
        }
      }
  }
}).$mount('#app')
